import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import styles from './HolderStyles';
import { NonVolatileTextMobile } from './constants';
import HolderTable from './holderTable';
import premium from './holder.png';
import premiumMobile from './mobileholder.png';
import ActionTypes from '../../../actions/types';
import { setOptionChainAction } from '../../../actions/optionChainAction';

const HolderModal = ({ showModal, setShowModal, symbol }) => {
  const { appReducer } = useSelector((state) => state);

  const { isMobile, holderList, accessLevel } = appReducer;
  const dispatch = useDispatch();
  const setShowHolder = (newState) => {
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  };
  return (
    <div style={isMobile ? { width: '220px' } : { width: '400px' }}>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showModal}
        onClose={() => setShowModal()}
      >
        <div style={isMobile ? styles.HolderModalMobile : styles.HolderModal}>
          <div
            onClick={() => {
              setShowHolder({ holderModal: false });
              dispatch(setOptionChainAction({ holderModal: false }));
            }}
            style={
              !isMobile
                ? styles.modalCloseButton
                : styles.modalCloseButtonMobile
            }
          >
            X
          </div>

          <div
            style={
              isMobile
                ? { ...styles.ModalTable, width: '98%' }
                : styles.ModalTable
            }
          >
            <div style={{ margin: '5px' }}>
              <h3 style={{ margin: 0 }}>
                {symbol} {NonVolatileTextMobile}
              </h3>
            </div>

            {accessLevel === 'fullaccess' ? (
              <HolderTable isMobile={isMobile} holderList={holderList} />
            ) : (
              <div style={styles.premiumdiv}>
                {' '}
                <div>
                  <img
                    height="100%"
                    width="100%"
                    src={isMobile ? premiumMobile : premium}
                    alt=""
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default HolderModal;



// WEBPACK FOOTER //
// ./src/components/Modals/Holders Modal/index.js